export const PROSPECT_GRADE_COLD = 107
export const PROSPECT_GRADE_HOT = 108
export const PROSPECT_GRADE_WARM = 109
